import { forwardRef, ReactNode, useImperativeHandle } from "react";
import LazyLoadComponent, { forceCheck } from "react-lazyload";

export const LazyLoad = forwardRef(function LazyLoadWithRef(
  { children, height = 200 }: { children: ReactNode; height?: number },
  ref
) {
  useImperativeHandle(ref, () => ({
    forceCheck,
  }));

  return (
    <LazyLoadComponent height={height} offset={200} unmountIfInvisible={true}>
      {children}
    </LazyLoadComponent>
  );
});
